/**
 * Search Form
 */

// Vendors
import $ from 'jquery';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import { createLocalStorageRecentSearchesPlugin } from '@algolia/autocomplete-plugin-recent-searches';
import algoliasearch from 'algoliasearch';

if ($('#autocomplete').length) {
  const appId = wlAlgolia.application_id;
  const apiKey = wlAlgolia.search_api_key;
  const indexName = wlAlgolia.indices.searchable_posts.name;
  const suggestionIndexName =
    wlAlgolia.indices.searchable_posts.name + '_query_suggestions';
  const searchClient = algoliasearch(appId, apiKey);

  const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
    key: 'instantsearch',
    limit: 3
  });

  const querySuggestionsPlugin = createQuerySuggestionsPlugin({
    searchClient: algoliasearch(appId, apiKey),
    indexName: suggestionIndexName,
    getSearchParams() {
      return recentSearchesPlugin.data.getAlgoliaSearchParams({
        hitsPerPage: 6
      });
    },
    transformSource({ source }) {
      return {
        ...source,
        sourceId: 'querySuggestionsPlugin',
        getItems(params) {
          if (!params.state.query) {
            return [];
          }

          return source.getItems(params);
        }
      };
    }
  });
  autocomplete({
    container: '#autocomplete',
    openOnFocus: true,
    placeholder: 'Search by Keyword',
    panelPlacement: 'end',
    detachedMediaQuery: 'none',
    onSubmit({ state }) {
      $('.search-form [name="s"]').val(state.query);
      $('.search-form').submit();
    },
    onStateChange({ prevState, state }) {
      if (prevState.query !== state.query) {
        $('.search-form [name="s"]').val(state.query);
        $('.search-form .btn').show();
      }
    },
    plugins: [recentSearchesPlugin, querySuggestionsPlugin],
    classNames: {
      submitButton: 'btn btn--red btn--block',
      inputWrapper: 'form__field',
      input: 'form__input',
      clearButton: 'u--display-none',
      panel: 'search-form-panel'
    }
  });
}

$('[data-search-form-show]').on('click', (event) => {
  event.preventDefault();
  $('body').addClass('search-form-is-visible');
  setTimeout(() => {
    $('.search-form [name="s"]').focus();
  }, 300);
});

$('[data-search-form-hide]').on('click', (event) => {
  event.preventDefault();
  $('body').removeClass('search-form-is-visible');
  $('.search-form [name="s"]').val('');
});

$('[data-search-form-toggle]').on('click', (event) => {
  event.preventDefault();
  if ($('body').hasClass('search-form-is-visible')) {
    $('body').removeClass('search-form-is-visible');
    $('.search-form [name="s"]').val('');
  } else {
    $('body').addClass('search-form-is-visible');
    setTimeout(() => {
      $('.search-form [name="s"]').focus();
    }, 300);
  }
});
